import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { EnrollmentContext } from '../modules/members/enrollments/context/MemberMyEnrollmentProvider';

const useValidateAPTCAmount = () => {
    const intl = useIntl();
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { isMinimumPremiumGlobalPropertyValueAvailable, minimumPremiumGlobalPropertyValue } = permissions || {};
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const {
        setError,
        setValue,
        formState: { errors },
    } = enrollmentPremiumFormContext;

    return premiumData => {
        const premium = { ...premiumData };
        enableContinueButton();
        if (!errors?.enrollmentPremiumDtoList?.[premium.month - 1]?.aptcAmount) {
            premium.netPremiumAmount = parseFloat(premium.grossPremiumAmount);

            if (premium.aptcAmount !== undefined) {
                const netPremiumAfterAptc = parseFloat(premium.netPremiumAmount) - parseFloat(premium.aptcAmount);
                if (netPremiumAfterAptc < parseFloat(premium.minimumPremium)) {
                    premium.aptcAmount = parseFloat(premium.grossPremiumAmount) - parseFloat(premium.minimumPremium);
                    premium.netPremiumAmount = parseFloat(premium.minimumPremium);
                } else {
                    premium.netPremiumAmount = netPremiumAfterAptc;
                }
            }
        }

        if (premium.stateSubsidyAmount !== undefined) {
            if (premium.netPremiumAmount > premium.minimumPremium) {
                if (premium.stateSubsidyAmount < 0) {
                    premium.stateSubsidyAmount = 0;
                }
                if (
                    premium.grossPremiumAmount !== undefined &&
                    premium.maxAptc !== undefined &&
                    premium.minimumPremium !== undefined
                ) {
                    var maxApplicable = 0;
                    //////minimum premium changes goes here
                    if (isMinimumPremiumGlobalPropertyValueAvailable) {
                        if (premium.year >= minimumPremiumGlobalPropertyValue) {
                            premium.minimumPremium = 0;
                        }
                    }
                    if (
                        parseFloat(premium.grossPremiumAmount) -
                            (parseFloat(premium.maxAptc) + parseFloat(premium.minimumPremium)) >
                        0
                    ) {
                        maxApplicable =
                            parseFloat(premium.grossPremiumAmount) -
                            (parseFloat(premium.maxAptc) + parseFloat(premium.minimumPremium));
                    }
                    if (premium.stateSubsidyAmount > maxApplicable) {
                        premium.stateSubsidyAmount = maxApplicable;
                    }
                }
            }
            premium.netPremiumAmount = parseFloat(premium.netPremiumAmount) - parseFloat(premium.stateSubsidyAmount);
        }
        if (premium.statePremiumCreditAmt !== undefined) {
            if (parseFloat(premium.netPremiumAmount) - parseFloat(premium.statePremiumCreditAmt) < 0) {
                premium.netPremiumAmount = 0;
            } else {
                premium.netPremiumAmount =
                    parseFloat(premium.netPremiumAmount) - parseFloat(premium.statePremiumCreditAmt);
            }
        }

        premium.netPremiumAmount = Number(parseFloat(premium?.netPremiumAmount).toFixed(2));

        setValue(`enrollmentPremiumDtoList.${premium.month - 1}.netPremiumAmount`, premium.netPremiumAmount || 0, {
            shouldDirty: true,
            shouldValidate: true,
        });
    };
};

export default useValidateAPTCAmount;
